import { Award } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const RecommendedBadge = ({ small = false }) => (
  <span title="Checked and recommended by the ShopAdvisor team" className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider rounded-full bg-emerald-600 text-white shrink-0 ${small ? "text-[9px] px-1.5 py-0.5" : "text-xs px-2.5 py-1"}`} data-testid={small ? "shop-recommended-badge" : "shop-recommended-profile-badge"}>
    <Award className={small ? "w-3 h-3" : "w-3.5 h-3.5"} />Recommended by ShopAdvisor
  </span>
);

export const RecommendToggle = ({ s, setS }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  const go = async () => {
    try { const { data } = await api.post(`/api/dir/admin/shops/${s.slug}/recommend`); setS({ ...s, ...data }); toast.success(data.recommended ? "Marked Recommended by ShopAdvisor" : "Recommendation removed"); } catch (e) { toast.error(errMsg(e)); }
  };
  return <button onClick={go} className={`h-10 px-4 rounded-full text-sm font-bold flex items-center gap-1.5 border transition-colors ${s.recommended ? "border-emerald-600 text-emerald-700 bg-emerald-50" : "border-slate-300 bg-white hover:border-slate-900"}`} data-testid="shop-recommend-toggle"><Award className="w-4 h-4" />{s.recommended ? "Recommended ✓ (admin)" : "Recommend (admin)"}</button>;
};
